import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { painPoints, disqualifier } from '../data/content';
export function PainPoints() {
  return <section className="w-full bg-plum-deep px-5 py-14 sm:px-8 sm:py-20" data-id="element-121" data-mp="26yfudq03jpqc">
      <div className="mx-auto max-w-letter" data-id="element-122" data-mp="26wbo51eq6emw">
        <h2 className="text-center font-display text-2xl font-bold leading-tight text-cream sm:text-3xl" data-id="element-123" data-mp="2bwr1hsz0bm4v">
          Esto es exactamente lo que te preocupa...
        </h2>
        <ul className="mt-9 space-y-3" data-id="element-124" data-mp="21zcvyoemghrc">
          {painPoints.map((item, index) => <motion.li key={item} initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-xl border border-cream/10 bg-plum px-5 py-4" data-id="element-125" data-mp="21x067p2mh33q" data-mpi={index}>
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-terracotta" aria-hidden="true" data-id="element-126" data-mp="1z0ot0se0bvgt">
                <XIcon className="h-4 w-4 text-cream" strokeWidth={3} data-id="element-127" data-mp="1tzhiwmoe6k6z" />
              </span>
              <span className="font-sans text-sm leading-relaxed text-cream/90 sm:text-base" data-id="element-128" data-mp="27s79z5is2fay">
                {item}
              </span>
            </motion.li>)}
        </ul>
        <p className="mt-6 rounded-xl border border-gold/40 bg-gold/10 px-5 py-4 text-center font-sans text-sm leading-relaxed text-cream sm:text-base" data-id="element-129" data-mp="1g2cgcwnw03gh">
          {disqualifier}
        </p>
      </div>
    </section>;
}